// extracted by mini-css-extract-plugin
export var active = "_lk-2";
export var recordingDot = "_lk-1";
export var recordingIndicator = "_lk-0";